module.exports = __webpack_public_path__ + "ca81d21e51c0c92b0367b736f61ce203.png";